/**
 * Iter XX.267a — Primary-surface mobile nav wrapper.
 *
 * The canonical `<MobileBottomNav>` lives inside `<Chat />` so all its
 * handlers can drive local Home/Chat state directly. On the other
 * primary surfaces (`/pulse`, `/me`, `/plus`) the exact same visual
 * shell is needed, but every tap must navigate back to `/chat` (with
 * a small hash marker to convey intent) so the transcript is preserved
 * and no duplicate conversation is created.
 *
 * Contract:
 *   currentRoute="pulse"  → Home / Gully / More all navigate to `/chat`
 *   Pulse tab stays highlighted; Memory Link navigates to `/me?tab=knows`
 *
 * The `#home` hash is read by Chat.jsx on mount to force `homePinned=true`.
 * The `#chat` hash focuses the composer. Both hashes are consumed and
 * removed by Chat.jsx so the URL stays clean.
 */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MobileBottomNav from "./MobileBottomNav";
import MoreSheet from "./MoreSheet";

export default function PrimarySurfaceNav({ currentRoute = "pulse", isPlus = false }) {
  const navigate = useNavigate();
  const [moreOpen, setMoreOpen] = useState(false);

  return (
    <>
      <MobileBottomNav
        currentRoute={currentRoute}
        isPlus={isPlus}
        onHomeTap={() => navigate("/chat#home")}
        onGullyTap={() => navigate("/chat#chat")}
        onMoreTap={() => setMoreOpen(true)}
      />
      <MoreSheet
        open={moreOpen}
        onClose={() => setMoreOpen(false)}
        onOpenSeason={() => navigate("/chat#season")}
        isPlus={isPlus}
        showEarn
        showJourney={false}
        showSeason={false}
      />
    </>
  );
}
